import React, { useState } from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import {
  Keybox,
  VisibilityStyles,
} from '../../styles/Popup/PasswordInput.styled';
import {
  Input,
} from "../../styles/Login.styled";


type PasswordProps = {
  value?: string;
  activeButton: boolean;
  passwordChange?: (e: React.Event) => void;
  disabled?: boolean;
  sign?: SignProps;
  $marginBottom?: string;
  $heightMobile?: string;
  $height?: string;
  $activeinput?: boolean;
  autoComplete?: string;
};

export default function PasswordInput(props: PasswordProps) {
  const [passwordShown, setPasswordShown] = useState(false);

  return (
    <Keybox
      error={props.sign}
      disabled={props.disabled}
      $height={props.$height}
      $marginBottom={props.$marginBottom}
      $heightMobile={props.$heightMobile}
      $activeinput={props.$activeinput}
    >
      <Input
        name="password"
        value={props.value}
        type={passwordShown ? 'text' : 'password'}
        placeholder="Пароль"
        onChange={props.passwordChange}
        maxLength={30}
        disabled={props.disabled}
        $activeButton={props.activeButton}
        $activeinput={props.activeButton}
        autoComplete={props.autoComplete}
      />
      <VisibilityStyles
        disabled={props.disabled ?? !props.activeButton}
        $activeinput={props.$activeinput}
        type="button"
        onClick={() => setPasswordShown(!passwordShown)}
      >
        {!passwordShown ? (
          <VisibilityOutlinedIcon
            sx={{ fontSize:'1rem' }}
          />
        ) : (
          <VisibilityOffOutlinedIcon
            sx={{ fontSize:'1rem' }}
          />
        )}
      </VisibilityStyles>
    </Keybox>
  );
}
